import * as yup from 'yup'

// Os dois PDFs são obrigatórios. Sem gabarito, a conversão deduz cada resposta
// da lei em vez de lê-la da banca — e é justamente essa dedução que a curadoria
// não tem como conferir em escala.
export const aiGenerationSchema = yup.object({
	examPdf: yup.mixed().required('Envie o PDF do caderno de provas'),
	answerKeyPdf: yup.mixed().required('Envie o PDF do gabarito'),
	answerKeyVariant: yup.string(),
	scopes: yup.string(),
	yearSelect: yup.array(),
	occupationSelect: yup.array(),
	bancaSelect: yup.array(),
	institutionSelect: yup.array(),
})
